import React from "react";
import style from "./index.module.scss";

export default function SubmitError({
    title,
    content
}: {
    title: string;
    content: string;
}) {
    return (
        <div className={style.root}>
            <h3>{title}</h3>
            <p>{content}</p>
        </div>
    );
}
